import { Grid, Group, Paper, Space, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import { IAuth } from "../../interfaces/IAuth";
import { dateTimeFormat } from "../../utils/date";
import { renderBusinessName } from "../../utils/render-business-name";
import { SalesInvoicesList } from "./sales-invoices-list";

export const OpenedInvoice = ({ data }: { data: any }) => {
  const params = useParams();
  const { t } = useTranslation("invoice");
  const { user } = useSelector((state: { auth: IAuth }) => state.auth);

  return (
    <Paper my={"xs"}>
      <Group align="apart">
        <Text fw={700} fz={"xl"}>
          {t("buyerName")}{" "}
          <Text c="gray.9" component="span">
            {renderBusinessName(user?.currentBusiness.type === "SUPPLIER" ? data?.receiverBusiness : data?.senderBusiness)}
          </Text>
          <Text c="gray.9">#{user?.currentBusiness.type === "SUPPLIER" ? data?.receiverBusiness?.refCode || "-" : data?.senderBusiness?.refCode || "-"}</Text>
        </Text>

        <Text component="span" ta="end" fz={"sm"} fw={500}>
          <Text>{t("ourBuyer.dateTime")}</Text>
          <Text>{dateTimeFormat(data.createdAt)} </Text>
          <Text> (Current)</Text>
        </Text>
      </Group>
      <Space h={"xl"} />
      <Grid>
        <Grid.Col>
          <SalesInvoicesList
            title={t("ourBuyer.openList")}
            filters={{
              businessId: `${params.id}`,
              type: "CONFIRMED",
            }}
          />
        </Grid.Col>
        <Grid.Col>
          <SalesInvoicesList
            title={t("ourBuyer.pendingList")}
            filters={{
              businessId: `${params.id}`,
              type: "PENDING",
            }}
          />
        </Grid.Col>
        <Grid.Col>
          <SalesInvoicesList
            title={t("ourBuyer.financedList")}
            filters={{
              businessId: `${params.id}`,
              type: "FINANCED",
            }}
          />
        </Grid.Col>
      </Grid>
    </Paper>
  );
};
